import React, { Component } from "react";

import { BrowserRouter as Router, Route } from "react-router-dom";
import { Element } from "react-scroll";

import Map from "./components/Map";

import Bio from "./components/Bio";
import Research from "./components/Research";
import Media from "./components/Media";

import Header from "./components/Header";
import Footer from "./components/Footer";

import CV from "./components/pages/CV";
import Teaching from "./components/pages/Teaching";

import data from "./components/data/data.json";

import "./App.css";
import Books from "./components/Books";

class App extends Component {
  state = data;

  render() {
    return (
      <Router basename="/alcaniz">
        <div className="App">
          <Element name="header" className="header">
            <Header />
          </Element>

          <Route
            exact
            path="/"
            render={(props) => (
              <React.Fragment>
                <Element name="map" className="map">
                  <Map />
                </Element>

                <Element name="bio" className="bio">
                  <Bio id="bio" />
                </Element>

                <Element name="media" className="media">
                  <Media media={this.state.media} blogs={this.state.blogs} />
                </Element>

                <Element name="book" className="book">
                  <Books id="book" />
                </Element>

                <Footer id="footer" />
              </React.Fragment>
            )}
          />
          <Route path="/cv" component={CV} />
          <Route path="/teaching" component={Teaching} />
        </div>
      </Router>
    );
  }
}

export default App;
